import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

export default function swiperRelated() {
  const sliderElement = document.querySelector('.related-posts-slider');
  if (sliderElement) {
      new Swiper('.related-posts-slider .swiper', {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          
          breakpoints: {
              768: {
                  slidesPerView: 2,
                  spaceBetween: 20
              },
              1024: {
                  slidesPerView: 4,
                  spaceBetween: 30
              }
          },
          
          autoplay: {
              delay: 5000,
              disableOnInteraction: true,
          },
          navigation: {
              nextEl: '.related-posts-slider .swiper-button-next',
              prevEl: '.related-posts-slider .swiper-button-prev',
          },
          grabCursor: true,
          speed: 400,
      });
  }
}
swiperRelated();